// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketColdStorage() {

     useGaspAnimations()

     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Cold Storage & Warehouse </li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>      
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}
                                                   <img src="assets/images/Marketicons/Positive-Storage-1.jpg" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Cold Storage & Warehouse</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>Integrated Cold Storage Solutions for Temperature-Sensitive Goods</span>
                                                    <p className="top">
                                                     Indus Refrigeration is a leader in designing and executing turnkey cold storage and warehouse refrigeration solutions that ensure product preservation, inventory safety, and operational efficiency across a wide range of industries. From food and dairy to pharmaceuticals and horticulture, our cold storage systems are engineered to maintain optimal temperatures, humidity levels, and air circulation—essential for long-term storage of perishable and temperature-sensitive products.
                                                    </p>
                                                    <p>
                                                     With expertise in both static and mobile cold storage applications, Indus provides scalable solutions for standalone cold rooms, multi-commodity cold storages, distribution centers, and export-oriented warehouses. Our energy-efficient systems help reduce operational costs while ensuring compliance with food safety and pharma-grade standards.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for Cold Storage & Warehousing:</h2>
                                                </div>
                                                    <p>Cold rooms, freezer rooms, and multi-chamber storage facilities (-40°C to +15°C)</p>

                                                    <p>Controlled Atmosphere (CA) and Modified Atmosphere (MA) storage systems</p>

                                                    <p>Banana ripening chambers and pre-cooling units for fresh produce</p>

                                                    <p>Ammonia and Freon-based refrigeration systems with high energy efficiency</p>

                                                    <p>PUF-insulated panels, doors, and automated temperature control systems</p>

                                                    <p>Turnkey solutions including civil, mechanical, electrical, and automation works</p>

                                                    <p>Indus Refrigeration’s customized cold storage infrastructure supports uninterrupted cold chain logistics—ensuring that your products stay fresh, compliant, and ready for market distribution, even under extreme conditions.</p>
                                               </div>    
                                        </div>
                                    </div>
                                 
                    
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketColdStorage;


